export default function Share() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 10.4988C17.5 10.643 17.4406 10.7776 17.3406 10.8769L10.8406 17.0292C10.6937 17.1702 10.4813 17.2054 10.3 17.1221C10.1188 17.0388 10 16.8561 10 16.6511V13.0687C5.25 13.184 4.37187 14.9816 3.44687 16.8818C3.3625 17.058 3.1875 17.1638 3 17.1638C2.9625 17.1638 2.92187 17.1606 2.88437 17.1509C2.65937 17.0965 2.5 16.8882 2.5 16.6511C2.5 11.992 3.075 8.11802 10 7.94178V4.34656C10 4.14148 10.1188 3.95884 10.3 3.87553C10.4813 3.79542 10.6937 3.83067 10.8406 3.96845L17.3406 10.1207C17.4406 10.22 17.5 10.3546 17.5 10.4988Z"
        stroke="white"
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </svg>
  )
}
